import { Box } from '@mui/material';
import Sucess from 'assets/icons/sucess.svg';
import { SubtitleMedium, SubtitleMediumBold } from 'common/typography/SubtitleMedium';
import { TitleMedium } from 'common/typography/TitleMedium';
import { FlexButton } from 'shared/components/Button/FlexButton';
import { theme } from 'styles/global-themes';

import { ButtomWrapper, IconWrapper, StepWrapper, TextBox } from './style';



export const StepSucess= () => {
  return (
    <StepWrapper>
      <IconWrapper src={Sucess} alt="sucess" />
      <Box textAlign="center">
        <TextBox>
          <TitleMedium color={theme.palette.common.black}>Informações enviadas com sucesso!</TitleMedium>
          <SubtitleMedium color={'#5F5E60'}>
            Agora é só aguardar o contato de um dos nossos vendedores. Enquanto isso, descubra os outros produtos
            Motorola!
          </SubtitleMedium>
        </TextBox>
      </Box>

      <Box display="flex" flexDirection="column">
        <TextBox>
          <FlexButton
            $backgroundColor={theme.palette.info.main}
            text="Descubra os produtos Motorola"
            handleClick={() => window.open('https://www.motorola.com.br', '_blank')}
          />
            <ButtomWrapper>
                 <SubtitleMediumBold  style={{cursor:'pointer', fontSize:'1rem', width:'fit-content'}} 
                 onClick={() => {
                     window.location.reload();
                    }} 
                  color={'#0E77DA'}>Enviar mais outro</SubtitleMediumBold>
            </ButtomWrapper>
        </TextBox>
      </Box>
    </StepWrapper>
  );
};
